// extracted by mini-css-extract-plugin
export var btgLogo = "Footer-module--btgLogo--kncFn";
export var logos = "Footer-module--logos--ClANe";
export var root = "Footer-module--root--k6EnZ";
export var socialIcon = "Footer-module--socialIcon--hnhar";
export var socialLinks = "Footer-module--socialLinks--sPy4T";
export var uai = "Footer-module--uai--16Wug";
export var uaiLogo = "Footer-module--uaiLogo--GGzHM";
export var wrapper = "Footer-module--wrapper--hXqu7";